export default __webpack_public_path__ + "f25ace88e7d5affee1afac387d162ce0.webp";